import { FC } from "react";
import { IconButton, Link, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { OpenInNew } from "@mui/icons-material";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";
import { BudgetWithIntegrations } from "@/store/budgets/utils/types/common";
import { BudgetDetails } from "@/services/cloudchipr.api";
import { BudgetScopeFiltersChip } from "@/components/pages/budgets-and-alerts/components/grids/budgets/components/cells/BudgetScopeFiltersChip";

interface BudgetsScopeCellProps {
  openInNew?: boolean;
  budget?: BudgetWithIntegrations | BudgetDetails;
}

export const BudgetsScopeCell: FC<BudgetsScopeCellProps> = ({
  budget,
  openInNew,
}) => {
  const budgetId = budget?.id;
  const viewId = budget?.view?.id;
  const name = budget?.view?.name;
  const filterTree = budget?.filter_tree;

  if (!budgetId) {
    return null;
  }

  if (filterTree) {
    return (
      <BudgetScopeFiltersChip
        openInNew={openInNew}
        filterTree={filterTree}
        budgetId={budgetId}
      />
    );
  }

  if (openInNew) {
    return (
      <Stack
        data-block-row-click
        direction="row"
        spacing={1}
        alignItems="center"
      >
        <Typography variant="inherit">{name}</Typography>
        <IconButton
          size="small"
          target="_blank"
          component={RouterLink}
          sx={{ p: 0.25 }}
          to={`/resource-explorer/${viewId}?budgetId=${budgetId}`}
        >
          <OpenInNew color="action" sx={{ fontSize: 18 }} />
        </IconButton>
      </Stack>
    );
  }

  return (
    <Link
      data-block-row-click
      component={RouterLink}
      to={`/resource-explorer/${viewId}?budgetId=${budgetId}`}
      color="primary"
      display="block"
      width="fit-content"
      target="_blank"
    >
      <TypographyWithTooltip maxWidth={200} variant="body2" title={name} />
    </Link>
  );
};
